import { render } from "./CN_OA.vue?vue&type=template&id=4b9f06d0&scoped=true"
import script from "./CN_OA.vue?vue&type=script&lang=js"
export * from "./CN_OA.vue?vue&type=script&lang=js"

import "./CN_OA.vue?vue&type=style&index=0&id=4b9f06d0&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\Administrator\\betaver_webpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9f06d0"]])

export default __exports__